import React from 'react';
import './App.css';

import { FormOpenPay } from './components/openPayForm/openPayForm';

import { PageWelcome,PagePrivacy, PageInfoFoto, PageTakeFoto, PageShowFoto, 
  PageLoading, PageInfoDonativo, PageRegistro,PageComplete } from './components/pages'

import ApolloClient from 'apollo-boost';

const apolloClient = new ApolloClient({
  uri: process.env.REACT_APP_GRAPHQL_URL,
  request: (operation) => {
    operation.setContext({
      headers: {
        "x-api-key":process.env.REACT_APP_X_API_KEY
      }
    })
  }  
});

class Carousel extends React.Component{
  shouldComponentUpdate = () => false

  componentDidMount() {
    ($("#carrousel") as any).carousel({pause:!0,touch:!1,keyboard:!1});
    ($("#carrouse") as any).carousel('pause')
  }

  render(){
    return (<div id="carrousel" className="carousel slide">{this.props.children}</div>)
  }
}

class CarouselSlide extends React.Component <{active?:boolean, loggedIn?:boolean}>{
  render(){
      return (
      <div className={`carousel-item ${(this.props.active?"active slide-start":"")}`}>
        {this.props.children}
      </div>)
  }
}


class App extends React.Component{
  PageTakeFoto: any;
  PageShowFoto:any;
  PageRegistro: any;
  FormOpenPay:any;
  PageComplete:any;

  //  this.prevSlide = this.prevSlide.bind(this) no autoblind 

  nextSlide = () =>{
    ($("#carrousel") as any).carousel('next');
    this.pauseSlide();
  }

  prevSlide = ()=> {
    ($("#carrousel") as any).carousel('prev');
    this.pauseSlide();
  }


  pauseSlide(){
    ($("#carrousel") as any).carousel('pause');
  }
  
  //Proceso posterior para que no active camar al iniciar 
  openCamera = () => {
    this.PageTakeFoto.initCamera();
    this.nextSlide();
  }

  setkeyItemUploadFile =(dataPresistquery:any) => {
    this.PageRegistro.updateState({keyItem:dataPresistquery.key});
    this.nextSlide();
  }

  setIdFormPay = (dataRegister:any) => {
    this.FormOpenPay.updateState({
      id:dataRegister.id,
      cantidad:dataRegister.cantidad
    });
    this.nextSlide();
  }

  setComplete = (dataPay:any) =>{
    console.log(dataPay)
    this.PageComplete.updateState({});
  }
  
  componentDidMount(){
    window.location.href = "https://www.rayados.com";
  }

  render(){
    return (
      <div></div>
    );


      return (
        <div className="App">
          <Carousel>
            <CarouselSlide active={true}>
              <PageWelcome actionNext={this.nextSlide} />
            </CarouselSlide>
            <CarouselSlide>
              <PagePrivacy actionNext={this.nextSlide} actionPrev={this.prevSlide} />
            </CarouselSlide>
            <CarouselSlide>
              <PageInfoFoto actionNext={this.openCamera} actionPrev={this.prevSlide} />
            </CarouselSlide> 
            <CarouselSlide>
              <PageTakeFoto ref={itemRef => {this.PageTakeFoto = itemRef}} actionNext={this.nextSlide} />
            </CarouselSlide>
            <CarouselSlide >
              <PageShowFoto ref={itemRef => {this.PageShowFoto = itemRef}} 
                actionPrev={this.prevSlide} actionComplete={this.setkeyItemUploadFile} actionLoading={this.nextSlide} clientAPollo={apolloClient}/>
            </CarouselSlide>   
            <CarouselSlide>
              <PageLoading message="Cargando imagen" />
            </CarouselSlide>
            <CarouselSlide>
              <PageInfoDonativo actionNext={this.nextSlide} />
            </CarouselSlide>
            <CarouselSlide>
              <PageRegistro ref={itemRef => {this.PageRegistro = itemRef}} actionComplete={this.setIdFormPay} clientAPollo={apolloClient}/>
            </CarouselSlide>
            <CarouselSlide>
              <FormOpenPay  ref={itemRef => {this.FormOpenPay = itemRef}} actionComplete={this.nextSlide} clientAPollo={apolloClient}/>
            </CarouselSlide>
            <CarouselSlide>
              <PageComplete  ref={itemRef => {this.PageComplete = itemRef}} />
            </CarouselSlide>            
          </Carousel>
        </div>
      );
  }
  
}

export default App;
